/** Legacy device status palette (shared-styles.html). */
export const DEVICE_STATUS_HEX = {
  active: '#0D47A1',
  warning: '#FFA700',
  danger: '#E53935',
  inactive: '#BDBDBD',
  loggedOut: '#000000'
}

/** Matches public.device_statuses / socket DEVICE_STATUS ids. */
export const DEVICE_STATUS_IDS = Object.freeze({
  ACTIVE: 1,
  WARNING: 2,
  DANGER: 3,
  INACTIVE: 4,
  LOGGED_OUT: 5
})

const STATUS_ID_HEX = {
  [DEVICE_STATUS_IDS.ACTIVE]: DEVICE_STATUS_HEX.active,
  [DEVICE_STATUS_IDS.WARNING]: DEVICE_STATUS_HEX.warning,
  [DEVICE_STATUS_IDS.DANGER]: DEVICE_STATUS_HEX.danger,
  [DEVICE_STATUS_IDS.INACTIVE]: DEVICE_STATUS_HEX.inactive,
  [DEVICE_STATUS_IDS.LOGGED_OUT]: DEVICE_STATUS_HEX.loggedOut
}

const NAMED_COLOR_HEX = {
  blue: DEVICE_STATUS_HEX.active,
  orange: DEVICE_STATUS_HEX.warning,
  yellow: DEVICE_STATUS_HEX.warning,
  red: DEVICE_STATUS_HEX.danger,
  grey: DEVICE_STATUS_HEX.inactive,
  gray: DEVICE_STATUS_HEX.inactive,
  black: DEVICE_STATUS_HEX.loggedOut,
  loggedout: DEVICE_STATUS_HEX.loggedOut
}

const STATUS_NAME_HEX = {
  active: DEVICE_STATUS_HEX.active,
  warning: DEVICE_STATUS_HEX.warning,
  danger: DEVICE_STATUS_HEX.danger,
  inactive: DEVICE_STATUS_HEX.inactive,
  loggedout: DEVICE_STATUS_HEX.loggedOut
}

const CSS_COLOR_PATTERN = /^(#|rgb|hsl|color\()/i

const normalizeStatusName = name =>
  String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')

/** Strip legacy suffixes like "Active (blue)" → "Active". */
export const formatDeviceStatusDisplayName = name => {
  if (name == null || name === '') {
    return name
  }

  const trimmed = String(name).trim()
  const withoutColorSuffix = trimmed.replace(/\s*\([^)]*\)\s*$/, '').trim()

  return withoutColorSuffix || trimmed
}

/**
 * Resolve API / legacy device status colors to a value MUI can parse (hex, rgb, etc.).
 *
 * @param {{ color?: string, statusId?: number, name?: string } | null | undefined} status
 * @param {import('@mui/material/styles').Theme} [theme]
 * @returns {string}
 */
export const resolveDeviceStatusColor = (status, theme) => {
  const fallback = theme?.palette?.text?.secondary ?? '#757575'

  if (!status) {
    return fallback
  }

  const { color, statusId, name } = status
  let resolved = null

  if (statusId != null && STATUS_ID_HEX[statusId]) {
    resolved = STATUS_ID_HEX[statusId]
  } else if (color) {
    const trimmed = String(color).trim()
    if (CSS_COLOR_PATTERN.test(trimmed)) {
      resolved = trimmed
    } else {
      resolved = NAMED_COLOR_HEX[trimmed.toLowerCase()] ?? null
    }
  }

  if (!resolved && name) {
    resolved = STATUS_NAME_HEX[normalizeStatusName(name)] ?? null
  }

  if (!resolved) {
    return fallback
  }

  if (resolved === DEVICE_STATUS_HEX.loggedOut && theme?.palette?.mode === 'dark') {
    return theme.palette.text.primary
  }

  return resolved
}
